const questions = {
    variable_1: '#1',
    init() {
        this.events();
    },
    events() {
        /**
         * Execute events
         */
        this.executeToggle();
        this.btnToggle();
    },    
    executeToggle() {
        jQuery('.toggle').on('click', function(){
            var toggle = jQuery(this).parent().attr('data-toggle');
            if(toggle == 'open'){
                jQuery(this).parent().attr('data-toggle', 'close');
            } else {
                jQuery(this).parent().attr('data-toggle', 'open');
            }
        });
    },
    btnToggle() {
        jQuery('.question-toggle div').on('click', function(){
            var toggle = jQuery(this).attr('data-toggle');
            jQuery('.question-toggle div').removeClass('active');
            jQuery(this).addClass('active');
            jQuery('.accordion-holder').addClass('accordion-hide');
            jQuery('[data-accordion='+toggle+']').removeClass('accordion-hide');
        });
    },
};
jQuery(() => {
    questions.init();
});